import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FileSpecification } from 'src/app/models/file-specifications/file-specification';
import { FileSpecificationStillsSettings } from 'src/app/models/file-specifications/file-specification-settings';

import {
  specMetaBadge,
  stillsDpiLabel,
  stillsFormatLabel,
  stillsProfileLabel,
  stillsQualityLabel,
  stillsSizeLabel,
} from '../shared/spec-labels';

@Component({
  selector: 'app-still-format-config-view',
  templateUrl: './still-format-config-view.component.html',
  styleUrls: ['./still-format-config-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StillFormatConfigViewComponent {
  @Input() stillsSpecs: FileSpecification[] = [];
  @Input() loaded = false;
  @Input() canWrite = false;
  @Input() canAudit = false;

  @Output() createStills = new EventEmitter<void>();
  @Output() updateStills = new EventEmitter<FileSpecification>();
  @Output() deleteStills = new EventEmitter<FileSpecification>();
  @Output() viewStillsHistory = new EventEmitter<FileSpecification>();

  private stillsSettings(spec: FileSpecification): FileSpecificationStillsSettings {
    return spec.value.settings as FileSpecificationStillsSettings;
  }

  metaBadge(spec: FileSpecification) {
    return specMetaBadge(spec);
  }

  formatLabel(spec: FileSpecification): string {
    return stillsFormatLabel(this.stillsSettings(spec).encoding.format);
  }

  dpiLabel(spec: FileSpecification): string {
    return stillsDpiLabel(this.stillsSettings(spec).encoding.dpi);
  }

  sizeLabel(spec: FileSpecification): string {
    return stillsSizeLabel(this.stillsSettings(spec).dimensions);
  }

  qualityLabel(spec: FileSpecification): string | null {
    return stillsQualityLabel(this.stillsSettings(spec).encoding.format);
  }

  profileLabel(spec: FileSpecification): string {
    return stillsProfileLabel(this.stillsSettings(spec).encoding.format);
  }

  onCreateStills(): void {
    this.createStills.emit();
  }

  onUpdateStills(row: FileSpecification): void {
    this.updateStills.emit(row);
  }

  onDeleteStills(row: FileSpecification): void {
    this.deleteStills.emit(row);
  }

  onViewStillsHistory(row: FileSpecification): void {
    this.viewStillsHistory.emit(row);
  }
}
